import { $, $$, body } from "@utils/dom";
import { on, off } from "@utils/listener";
import { INVIEW_ENTER } from "@scroll/constants";

class SiteFooter {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this.images = [...$$('.site-footer__img', this.el)];
    this.closeBtn = $('.site-footer__closeBtn', this.el);
    this.newsletterBtn = $('.site-footer__newsletterBtn', this.el);
    this.imgBox = $('.site-footer__imgBoxWrap', this.el);
    this.newsletter = $('.site-footer__newsletterForm', this.el);

    this._newsletterExpanded = false;
    this.randomImage = null;

    this._toggleNewsletter = this._toggleNewsletter.bind(this);
    this._onScrollCall = this._onScrollCall.bind(this);

  }

  init() {
    this._selectRandomImage();
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;
    this.emitter = null;

    this.images = null;
    this.closeBtn = null;
    this.newsletterBtn = null;
    this.imgBox = null;
    this.newsletter = null;

    this._newsletterExpanded = null;
    this.randomImage = null;

    this._toggleNewsletter = null;
    this._onScrollCall = null;
  }

  _bindEvents(){
    if (this.closeBtn) on(this.closeBtn,'click', this._toggleNewsletter);
    if (this.newsletterBtn) on(this.newsletterBtn,'click', this._toggleNewsletter);
    if( this.emitter ) this.emitter.on('SiteScroll.site-footer', this._onScrollCall);
  }
  _unbindEvents(){
    if (this.closeBtn) off(this.closeBtn,'click', this._toggleNewsletter);
    if (this.newsletterBtn) off(this.newsletterBtn,'click', this._toggleNewsletter);
    if( this.emitter ) this.emitter.off('SiteScroll.site-footer', this._onScrollCall);
    
  }

  _toggleNewsletter(){
    this.newsletterExpanded = !this.newsletterExpanded;
  }

  _selectRandomImage(){

    if (this.images.length) {

      let randomIndex = Math.floor(Math.random() * this.images.length);
      this.randomImage = this.images[randomIndex];

      this.randomImage.setAttribute('aria-hidden', false);
    }
  }

  _onScrollCall(direction, obj){
    if( obj.el !== this.el ) return;

    this._inView = direction === INVIEW_ENTER;

    // toggle active slide video playback
    body.classList[this._inView ? 'add' : 'remove']('--js-site-footer-inview');
  }

  get newsletterExpanded() { return this._newsletterExpanded; }
  set newsletterExpanded(value) {
    this._newsletterExpanded = value;

    if (this.closeBtn) {
      this.closeBtn.setAttribute('aria-expanded', !this.newsletterExpanded);
      this.closeBtn.setAttribute('aria-hidden', !this.newsletterExpanded);
    }
    
    if (this.newsletterBtn) {
      this.newsletterBtn.setAttribute('aria-expanded', this.newsletterExpanded);
      this.newsletterBtn.setAttribute('aria-hidden', this.newsletterExpanded);
    }

    if (this.imgBox) this.imgBox.setAttribute('aria-hidden',this.newsletterExpanded);
    if (this.newsletter) this.newsletter.setAttribute('aria-hidden',!this.newsletterExpanded);

    this.emitter.emit('SiteScroll.update');
  }
}

export default SiteFooter;
